import {RouteProps} from 'config/navigation';
import {MdFastfood} from 'react-icons/md';
import ProductsReports from './products-reports';
import UsersReports from './users-report';
import {FaUsers} from 'react-icons/fa';
import {IoBagHandle} from 'react-icons/io5';
import AdditionalsReports from './additionals-report';

const productsReportsPages: RouteProps = {
  name: 'Produtos',
  path: 'products',
  permission: 'products.findAll',
  icon: <MdFastfood />,
  subRoutes: [
    {
      path: '',
      element: <ProductsReports />,
      permissions: ['products.findAll'],
    },
  ],
};

const usersReportsPages: RouteProps = {
  name: 'Usuários',
  path: 'users',
  permission: 'users.findAll',
  icon: <FaUsers />,
  subRoutes: [
    {
      path: '',
      element: <UsersReports />,
      permissions: ['users.findAll'],
    },
  ],
};

const additionalsReportsPages: RouteProps = {
  name: 'Adicionais',
  path: 'additionals',
  permission: 'users.findAll',
  icon: <IoBagHandle />,
  subRoutes: [
    {
      path: '',
      element: <AdditionalsReports />,
      permissions: ['users.findAll'],
    },
  ],
};

export default [productsReportsPages];
